import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <img src="assets/images/logo1.png" alt="" width="90px" />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/improvement-nuggets"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Improvement Nuggets
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/escaping-mediocrity"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Escaping Mediocrity
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/books" className="nav-links" onClick={closeMobileMenu}>
                Books
              </Link>
            </li>

            <li>
              <Link
                to="/about-me"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                About Me
              </Link>
            </li>
          </ul>
          {button && <Button buttonStyle="btn--outline">About Me</Button>}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
